export class PermissionRoleEntity {
  corpId: number;
  id: number;
  alias: string;
  name: string;
}


